module.exports = __webpack_public_path__ + "static/media/manu-4.f3eb7020.png";